import React from 'react';
import CrossRoad from "../UI/Crossroad";

const CrossRoad_5CRed_FBlue_GBlue_5BBlue_5ABlue = () => <CrossRoad coords="1864.000000, 613.000000"/>;
export default CrossRoad_5CRed_FBlue_GBlue_5BBlue_5ABlue;
